import React from 'react';
import PropTypes from 'prop-types';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import SearchHighlight from '../SearchHighlight';
import ContactListItemSubtitle from '../ContactList/ContactListItemSubtitle';

const Subtitle = ({ contact, searchTerm, onClickContactInfo, onClickMainContact, children }) => {
  const { mainContact, note } = contact;
  const parentName = mainContact && getFullNameWithTitle(mainContact);
  let subtitle = children || contact.user.subtitle;

  if (searchTerm && subtitle) {
    if (typeof subtitle === 'string') {
      subtitle = <SearchHighlight text={subtitle} toHighlight={searchTerm} />;
    } else {
      subtitle = subtitle.props.children && (
        <SearchHighlight text={subtitle.props?.children} toHighlight={searchTerm} />
      );
    }
  }

  return (
    <ContactListItemSubtitle
      text={subtitle}
      parentName={parentName}
      note={note}
      toHighlight={searchTerm}
      onClickShowMore={onClickContactInfo}
      onClickMainContact={onClickMainContact}
    />
  );
};

Subtitle.defaultProps = {
  onClickContactInfo: () => {},
  onClickMainContact: () => {},
  children: null,
  searchTerm: '',
};

Subtitle.propTypes = {
  contact: PropTypes.shape({
    user: PropTypes.shape({
      subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      id: PropTypes.string,
    }),
    note: PropTypes.string,
    mainContact: PropTypes.shape({ id: PropTypes.string }),
    parentName: PropTypes.string,
  }).isRequired,
  searchTerm: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClickContactInfo: PropTypes.func,
  onClickMainContact: PropTypes.func,
};

export default Subtitle;
